/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 23.06.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { ListGroupItem } from 'external/react-bootstrap';

class MapConfigLogicalLayerListItem extends React.Component {

    onClick(e){
        this.props.onClick(this.props.item, e);
    }

    render(){
        const { selectedLogicalLayers, selectedLayerSet } = this.props;

        const dataItem = this.props.item,
            item = dataItem && (dataItem.item || dataItem);

        let alreadyExisting = selectedLogicalLayers && selectedLogicalLayers.indexOf(item.uuid) >= 0;

        let title = item.title + (alreadyExisting ? ' (in Kartenkonfiguration bereits enthalten)' : '');
        title = title + (item.description ? ` (Beschreibung: ${item.description.slice(0, 50)}...)` : '');

        return (
            <ListGroupItem
                disabled={!selectedLayerSet || alreadyExisting}
                onClick={this.onClick.bind(this)}
                title={item.description || ''}
            >
                {title}
            </ListGroupItem>
        );
    }
}

MapConfigLogicalLayerListItem.propTypes = {
    ...ListGroupItem.propTypes,
    item: PropTypes.object.isRequired,
    onClick: PropTypes.func
};

export default MapConfigLogicalLayerListItem;



// WEBPACK FOOTER //
// ./js/components/MapConfigLogicalLayerListItem.jsx